// src/pages/Reports/IssuanceReporting/shared/exportReport.ts
// README.md mục 7 — export Excel/CSV dùng CHUNG cho toàn bộ báo cáo dạng danh sách trong module
// IssuanceReporting (BE trả file qua IReportExportService, xem TicketService — mỗi báo cáo có
// action riêng "<Action>/Export?...&format=Xlsx|Csv").
//
// api.download(url) (helpers/api_helper.ts) chỉ nhận URL ĐẦY ĐỦ (đã có query string), KHÔNG tự
// nhận params riêng như api.get(url, params) — nên phải tự build query string ở đây, dùng đúng
// quy tắc api.get() đang áp dụng (bỏ rỗng/null/undefined, mảng sinh nhiều cặp key=value lặp lại —
// xem README_RULE.md mục 1 & 2) để đảm bảo nhất quán.
//
// Xử lý blob → tải file: theo đúng pattern đã kiểm chứng ở slices/sinhBoSoQr/thunk.ts#exportQrCsv.

import { APIClient } from 'helpers/api_helper';

const api = new APIClient();

export type ReportExportFormat = 'Xlsx' | 'Csv';

const buildQueryString = (params: Record<string, any>): string => {
  const pairs: string[] = [];
  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (value === null || value === undefined || value === '') return;
    if (Array.isArray(value)) {
      value.forEach((item) => pairs.push(`${key}=${encodeURIComponent(item)}`));
    } else {
      pairs.push(`${key}=${encodeURIComponent(value)}`);
    }
  });
  return pairs.join('&');
};

/**
 * Gọi action "<baseUrl>/Export" và tự trigger tải file về máy người dùng.
 * @param baseUrl URL action GỐC (không có "/Export"), VD `${ISSUANCE_REPORTS_BASE}/IssuanceSummary`
 * @param params filter hiện tại của báo cáo (PageIndex/PageSize không cần truyền — BE tự lặp trang)
 * @param format "Xlsx" | "Csv"
 * @param fileNamePrefix tên file gợi nhớ, VD "TongHopPhatHanh"
 */
export async function downloadReportExport(
  baseUrl: string,
  params: Record<string, any>,
  format: ReportExportFormat,
  fileNamePrefix: string,
): Promise<void> {
  const query = buildQueryString({ ...params, format });
  const response = await api.download(`${baseUrl}/Export?${query}`);
  const blobContent = (response as any)?.data ?? response;
  const blob = new Blob([blobContent]);
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', `${fileNamePrefix}_${Date.now()}.${format === 'Xlsx' ? 'xlsx' : 'csv'}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
}
